class DestinationPromoMessage {

    className: string;
    text: string[];
    price: string;

    constructor (private currentDestination,
                private $interpolate) {
        currentDestination.getCurrentDestination().then(dest => {
            let text = dest.PromoText;
            let matches = text && text.match(/\S*\d+\S*/);
            this.price = matches && matches[0];
            this.text = this.price && text.split(this.price);
        });
    }
}

angular
    .module('TR')
    .directive('destinationPromoMessage', (): ng.IDirective => {

        return {
            controller: DestinationPromoMessage,
            controllerAs: 'dpm',
            bindToController: {
                className: '='
            },
            replace: true,
            template: `<p class="destination-promo-message" ng-if="dpm.price">
                        {{dpm.text[0]}} <span class="price">{{dpm.price}}</span>{{dpm.text[1]}}
                        </p>`
        };
    });
